
import type { IAnalysisDirectory, IHistoryResponse, IProject } from '@/types';
import { container } from '@eureka/services';
import type { ICoreDataWrapper } from '@eureka/services/src/exception';
import { getLlmModelHeader, LLM_FUNCTION_ID } from '@eureka/utils/llm-model';

// project 函数式请求统一注入所选 LLM 模型 header（functionId 写死）
const llmModelHeader = getLlmModelHeader(LLM_FUNCTION_ID.QUICK_RESEARCH)

function handleResponse(res: ICoreDataWrapper<any>) {
    return res.data;
}

export function getProjectHistory(projectId: string, type: 'SESSION_CHAT' | 'MODEL_ANALYSIS'): Promise<any> {
    return container.RnDHttp.get<ICoreDataWrapper<IHistoryResponse>>({
        url: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/air/history/records`,
        params: {
            business_id: projectId,
            session_type: type,
        },
        headers: llmModelHeader,
    }).then(handleResponse)
}

export function analysisDirectory(projectId: string, query: string, directory?: IAnalysisDirectory[]) {
    return container.RnDHttp.post<ICoreDataWrapper<IAnalysisDirectory[]>>({
        url: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/project/analysis-directory`,
        data: {
            project_id: projectId,
            query,
            directory_list: directory,
        },
        headers: llmModelHeader,
    }).then(handleResponse)
}

export function createProject(projectId: string) {
    const url = `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/project/create`
    return container.RnDHttp.post<ICoreDataWrapper<IProject>>({
        url,
        data: {
            project_id: projectId,
        },
        headers: llmModelHeader,
    }).then(handleResponse)
}
